import { useEffect, useState } from "react";
import api, { fmtDateTime } from "@/lib/api";
import { AppuntamentoModal } from "@/components/AppuntamentoModal";
import { CalendarPlus, Plus, Clock, Link2Off } from "lucide-react";

const STATO_CLS = {
  svolto: "text-emerald-600 bg-emerald-400/10 border-emerald-400/30",
  annullato: "text-slate-500 bg-slate-100 border-slate-300",
  non_presentato: "text-red-600 bg-red-400/10 border-red-400/30",
  confermato: "text-sky-600 bg-sky-400/10 border-sky-400/30",
  da_verificare: "text-amber-600 bg-amber-400/10 border-amber-400/30",
};

export function AppuntamentiScheda({ entity, prefill, title = "Appuntamenti" }) {
  const [appts, setAppts] = useState(null);
  const [modal, setModal] = useState(false);

  const load = () => api.get("/appuntamenti/by-entity", { params: entity }).then((r) => setAppts(r.data)).catch(() => setAppts([]));
  useEffect(() => { load(); }, [JSON.stringify(entity)]); // eslint-disable-line

  const now = new Date();
  const futuri = (appts || []).filter((a) => new Date(a.data) >= now);
  const passati = (appts || []).filter((a) => new Date(a.data) < now);

  const Riga = ({ a }) => (
    <div key={a.id} data-testid={`scheda-appt-${a.id}`} className="flex items-center gap-3 p-3 rounded-lg border border-[var(--border)] bg-white/60">
      <CalendarPlus size={16} className="text-[#FC82ED] shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium truncate">{a.titolo}</div>
        <div className="text-xs text-[var(--muted)]">{(a.tipo || "").replace(/_/g, " ")} · {fmtDateTime(a.data)}{a.cliente_nome ? ` · ${a.cliente_nome}` : ""}</div>
      </div>
      {a.da_collegare && <span className="inline-flex items-center gap-1 text-[9px] font-bold uppercase text-amber-600 bg-amber-400/10 border border-amber-400/30 rounded-full px-1.5 py-0.5" title="Appuntamento da collegare a una scheda"><Link2Off size={10} /> da collegare</span>}
      {a.stato && <span className={`text-[10px] uppercase font-semibold px-2 py-0.5 rounded-full border ${STATO_CLS[a.stato] || "text-slate-500 bg-slate-100 border-slate-300"}`}>{(a.stato || "").replace(/_/g, " ")}</span>}
    </div>
  );

  return (
    <div data-testid="appuntamenti-scheda">
      <div className="flex items-center justify-between mb-3">
        <div className="font-semibold flex items-center gap-2"><Clock size={16} className="text-[#FC82ED]" /> {title}</div>
        <button data-testid="scheda-nuovo-appuntamento-btn" onClick={() => setModal(true)} className="text-sm font-semibold text-[#FC82ED] flex items-center gap-1 hover:underline"><Plus size={15} /> Nuovo appuntamento</button>
      </div>
      {appts === null ? <div className="skeleton h-16 rounded-xl" /> : (
        (futuri.length + passati.length) === 0 ? (
          <div className="text-sm text-[var(--muted)]">Nessun appuntamento. Sincronizzato con l'Agenda.</div>
        ) : (
          <div className="space-y-4">
            {futuri.length > 0 && (
              <div className="space-y-2">
                <div className="text-[10px] font-bold uppercase tracking-wider text-[var(--muted)]">Prossimi</div>
                {futuri.map((a) => <Riga key={a.id} a={a} />)}
              </div>
            )}
            {passati.length > 0 && (
              <div className="space-y-2">
                <div className="text-[10px] font-bold uppercase tracking-wider text-[var(--muted)]">Passati</div>
                {passati.map((a) => <Riga key={a.id} a={a} />)}
              </div>
            )}
          </div>
        )
      )}
      {modal && <AppuntamentoModal prefill={prefill} onClose={() => setModal(false)} onSaved={() => { setModal(false); load(); }} onDeleted={() => { setModal(false); load(); }} />}
    </div>
  );
}
